import { CloseSharp } from "@mui/icons-material";
import { Breakpoint, IconButton, Slide, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TransitionProps } from "@mui/material/transitions";
import type { JSX } from "react";
import React from "react";

type PropsType = {
  open: boolean;
  title?: JSX.Element | string;
  content?: JSX.Element;
  onClose: () => void;
  maxWidth?: false | Breakpoint;
  titleStyle?: any;
  [key: string]: any;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomDialog = (props: PropsType) => {
  const {
    open,
    title,
    content,
    onClose,
    maxWidth,
    titleStyle,
    fullScreen,
    ...dialogProps
  } = props;
  const handleClose = (
    _event: React.SyntheticEvent,
    reason: "escapeKeyDown" | "backdropClick",
  ) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }

    onClose();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      slots={{ transition: fullScreen ? Transition : undefined }}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      disableEscapeKeyDown
      maxWidth={maxWidth ?? "sm"}
      {...dialogProps}
    >
      <DialogTitle>
        <Stack
          useFlexGap
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <div style={titleStyle}>{title}</div>
          <IconButton onClick={onClose} sx={{ color: "grey.950" }}>
            <CloseSharp />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
